import { styled } from 'linaria/react';
import { ReactComponent as Check } from '../../../assets/svg/UspCheck.svg';
import { theme } from '../../../components/Theme';
import { toRem } from '../../../helpers';

const USPList = styled.ul`
  margin-top: 2rem;
  ${theme.below.md} {
    display: flex;
    flex-wrap: wrap;
  }
`;

const ListItem = styled.li`
  display: flex;
  align-items: center;
  padding-bottom: 0.5rem;
  font-size: ${toRem(12)};
  margin-right: 1rem;
  ${theme.above.md} {
    margin-right: 0;
    font-size: ${toRem(14)};
    &:last-child {
      padding-bottom: 0;
    }
  }
`;

const USPCheck = styled(Check)`
  margin-right: ${toRem(6)};
  path {
    fill: ${theme.colorScheme.primary};
  }
`;

const Saving = styled('span')`
  font-weight: ${theme.fontWeights.bold};
  padding-left: ${toRem(5)};
`;

const style = { ListItem, Saving, USPCheck, USPList };

export default style;
